import React from 'react';
import SitesTable from 'src/features/milestones/sites/SitesTable';
import MilestonesContent from './layout/MilestonesContent';

const SitesPage = () => {
  return <MilestonesContent contentType="table" content={<SitesTable />} />;
};

export default SitesPage;
